import { render, staticRenderFns } from "./MenuGroup.vue?vue&type=template&id=7ff84202"
import script from "./MenuGroup.vue?vue&type=script&lang=js"
export * from "./MenuGroup.vue?vue&type=script&lang=js"
import style0 from "./MenuGroup.vue?vue&type=style&index=0&id=7ff84202&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff84202')) {
      api.createRecord('7ff84202', component.options)
    } else {
      api.reload('7ff84202', component.options)
    }
    module.hot.accept("./MenuGroup.vue?vue&type=template&id=7ff84202", function () {
      api.rerender('7ff84202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/MenuGroup.vue"
export default component.exports